import PageBuilderService from '@/Services/Page/PageBuilderService'
import PageService from '@/Services/Page/PageService'

// Object.entries(Services).map(([key, value]) => {
//   console.log('key', key)
// })


const PageModule = {
  namespaced: true,
  state: {
    services: {},
    service: null,
    setting: {},
    data: {}
  },
  mutations: {
    initService (state, opt) {
      // state.services[opt.name] = opt.service
      state.service = opt.service
      return Promise.resolve()
    },
    initPageSetting (state, opt) {
      if (!opt.setting || opt.setting === undefined) throw new Error('Setting Not Found')
      state.setting = opt.setting
      return Promise.resolve()
    },
    async setData (state, data) {
      state.data[data.key] = data.data
    }
  },
  getters: {
    service: (state, getters) => (name = false) => {
      return state.service // state.services[name]
    },
    tableData: (state, getters, rootState, rootGetters) => (data = false) => {
      // console.log('state.data[rootGetters.page_id]', state.data[rootGetters.page_id])
      const categorySetting = getters.categorySetting()
      const identifer = categorySetting.identifer 
        ? categorySetting.identifer 
        : categorySetting.aditionalFilter
          ? categorySetting.aditionalFilter.model.type
          : false
      const tableData = data !== false ? data : state.data[rootGetters.page_id]
      return identifer ? tableData.filter((item) => item[identifer]) : tableData
    },
    categorySetting: (state, getters, rootState, rootGetters) => () => {
      if (!rootGetters.survay_id || !rootGetters.page_id) return {}
      return state.setting.categories.find(category => category.slug === rootGetters.page_id)
    }
  },
  actions: {
    async mainInit ({ dispatch, commit, state, rootState, getters, rootGetters }, serviceName) {
      try {
        await Promise.all([
          commit('initPageSetting', { 
            setting: PageBuilderService.getInstance(rootGetters.router.app).build
              .find(item => item.slug === rootGetters.survay_id)
          }),
          commit('initService', { 
            service: PageService.getInstance(this._vm)
          })
        ])
      } catch {}
      
      return false 
    },
    checkCategory ({ dispatch, commit, state, rootState, getters, rootGetters }) {
      if (!rootGetters.page_id) return
      try {
        if (!Array.prototype.some.call(state.setting.categories, (item) => item.slug === rootGetters.page_id)) {
          throw new Error('Category Not Found')
        }
      } catch {
        rootGetters.router.replace({ name: 'NotFound' }).catch((e) => {})
      }
      return false
    },
    get ({ dispatch, commit, state, rootState, getters, rootGetters }, { params, worldMap = false }) {
      return new Promise((resolve, reject) => 
        getters
          .service()
          .requestMutation({ 
            columns: [
              ...getters.categorySetting().data.select, 
              getters.categorySetting().aditionalFilter?.model.type
            ],
            locale: rootGetters.locale,
            params
          })
          .get(state.setting.fetchName)
          .then(
            async response => {
              // console.log('19', response)
              if (!worldMap) {
                await commit('setData', { data: response.data.data, key: rootGetters.page_id })
                resolve(true)
              } else {
                resolve(response.data.data)
              }
            }, 
            response => {

              // localStorage.removeItem('token')
              // reject(response)
            
            })
      )
    }
  }
}

export default PageModule                                                               


